import React, { useEffect, useState, useRef } from 'react';
import styled from '@emotion/styled';
import css from '@emotion/css';
import { format } from 'date-fns';
import CheckOutsideClick from 'components_v2/common/CheckOutsideClick/CheckClickOutside';
import LoadMenu from 'components_v2/mobile/Menu/MenuLoadableLoader';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import Login from 'components/Login/Login';
import { getPrcCookieValue } from 'utils/primeUtil';
import Cookie from 'utils/cookies';
import { EpaperCalendar } from '../../../routes/printhomepage/components/common/EpaperCalendar';
import { EpaperTabs } from '../../../routes/printhomepage/components/common/EpaperTabs';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import { device } from '../../../components/Print/device';
import { ET_DOMAIN_MWEB, ET_DOMAIN_WEB } from '../../../constants'


//import { HamburgerIcon } from 'components/Print/HamburgerIcon';


interface IStyledHeader {
    isImage?: string;
    isLoaded?: string;
    state?: string;
    Type?: string;
    isSticky?: string;
    Icontype?: string;
}

interface EpaperData {
    city: string;
    defaultView?: string;
    href: string;
    name: string;
    seoName: string;
}

interface IEpaperHeaderProps {
    isWapView: boolean;
    editionDate: Date | undefined;
    lastActiveDate: string | undefined;
    isAppView: boolean;
    showCalendar: boolean;
    // handleCalendarOpen: (e: React.MouseEvent<HTMLButtonElement>) => void;
    closeCalendar: () => void;
    //innerRef: React.RefObject<HTMLDivElement>;
    scrollTosections?: (label: string) => void;
    headerData?: { [key: string]: any } | undefined;
    isBlocked: boolean;
    pageType: string;
    toipLayout: boolean;
    printLayout: boolean;
    currentCountry: string;
   // killSwitchStatus: any;
    msid: string;
    articleSectionData: any;
    showToiPlusEntryPoints: boolean;
    newsData: any;
    showTOIPlus: boolean;
}

const EpaperHeaderV2: React.FC<IEpaperHeaderProps> = ({
    isWapView,
    editionDate,
    lastActiveDate,
    isAppView,
    scrollTosections,
    headerData,
    isBlocked,
    pageType,
    toipLayout,
    printLayout,
    currentCountry,
    //killSwitchStatus,
    msid,
    articleSectionData,
    showToiPlusEntryPoints,
    newsData,
    showTOIPlus,
}) => {
    const [date, setDate] = useState<Date>();
    const calendarRef = useRef<HTMLDivElement>(null);
    const [showList, setShowList] = useState<boolean>(false);
    const [showSocialDropdown, setShowSocialDropdown] = useState<boolean>(false);

    const [openMenuState, setOpenMenuState] = useState<boolean>(false);
    const [showEpaperCalendar, setShowEpaperCalendar] = useState<boolean>(false);
    const [epapers] = useState([
        "the-economic-times",
        "the-times-of-india",
        "maharashtra-times",
        "mirror",
    ]);
   // const { data: { ps = null } = {} } = killSwitchStatus || {};
    const scrollToBlocker = () => {
        const element = typeof document !== 'undefined' && document.getElementById('print-blocker-nudge');
        if (element) {
            element.scrollIntoView({ block: 'center' });
        }
    };
    const closeCalendar = () => {
        setShowEpaperCalendar(false);
    };
    const handleCalendarOpen = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        if (showEpaperCalendar) {
            setShowEpaperCalendar(false);
            return;
        }

        // if (isBlocked) {
        //       e.preventDefault();
        //       scrollToBlocker();
        //       return;
        // }
        setShowEpaperCalendar(true);
        const prcValue = getPrcCookieValue();
        const ssoid = Cookie.get('ssoid') || Cookie.get('ssoId');
        const categoryForGA = isWapView ? 'WAP-Printedlandingpage' : 'WEB-Printedlandingpage';
        analyticsWrapper(
            'ga',
            'send',
            'event',
            categoryForGA,
            'Datechange_click',
            `${!ssoid && prcValue === 0 ? -1 : prcValue}_${editionDate}`
        );
    };



    const ETDomain = isWapView || isAppView ? ET_DOMAIN_MWEB : ET_DOMAIN_WEB;

    const [dropDownEpaperData, setDropDownEpaperData] = useState<Record<string, EpaperData>>({
        "the-economic-times": {
            "city": "delhi",
            "defaultView": "print-edition",
            "href": `https://${ETDomain}/timesepaper/publication-the-economic-times,city-delhi.cms`,
            "name": "The Economic Times",
            "seoName": "the-economic-times"
        },
        "the-times-of-india": {
            "city": "delhi",
            "defaultView": "print-view",
            "href": `https://${ETDomain}/timesepaper/publication-the-times-of-india,city-delhi.cms`,
            "name": "The Times Of India",
            "seoName": "the-times-of-india"
        },
        "mirror": {
            "city": "bangalore",
            "href": `https://${ETDomain}/timesepaper/publication-mirror,city-bangalore.cms`,
            "name": "Mirror",
            "seoName": "mirror"
        },
        "maharashtra-times": {
            "city": "mumbai",
            "href": `https://${ETDomain}/timesepaper/publication-maharashtra-times,city-mumbai.cms`,
            "name": "Maharashtra Times",
            "seoName": "maharashtra-times"
        }
    })

    const [epapertabData, seteEpapertabData] = useState([
        {
            'name': 'Print View',
            'href': dropDownEpaperData['the-times-of-india'].href,
        },
        {
            'name': "Digital View",
            'href': '',
        }
    ]);

    useEffect(() => {

        if (editionDate) {
            setDate(new Date(editionDate.toString().replace(/-/g, '/')));
        } else {
            setDate(new Date());
        }


        var getPreferences = localStorage.getItem("epaper_preferences");
        if (getPreferences) {
            let preferencesData = JSON.parse(getPreferences);
            let finalObj = { ...dropDownEpaperData };
            epapers.forEach((paper) => {
                if (preferencesData[paper]) {
                    preferencesData[paper].name = dropDownEpaperData[paper].name;
                    preferencesData[paper].href = `https://${ETDomain}/timesepaper/publication-${paper},city-${preferencesData[paper].city}.cms`
                }
                finalObj[paper] = preferencesData[paper]
            })
            setDropDownEpaperData(finalObj);
        }
        seteEpapertabData([
            {
                'name': 'Print View',
                'href': dropDownEpaperData['the-times-of-india'].href,
            },
            {
                'name': "Digital View",
                'href': '',
            }
        ]);
    }, []);



    useEffect(() => {
        if (date) {
            const epaperDate = format(date, 'YYYY-MM-DD')?.toLowerCase();
            sessionStorage.setItem('epaper_sync_date', epaperDate);
        }
    }, [date]);


    const closeMenu = () => {
        setOpenMenuState(false);
        if (toipLayout) {
            sendGaThroughProps({
                data: {
                    gaCategory: 'WAP-Prime-AS',
                    gaAction: 'NavBar-Hamburger',
                    gaLabel: 'Close',
                },
            });
        }
        if (printLayout && pageType !== 'printeditionas') {
            const navigationBar = document.getElementById('toi-print-navigation');
            if (navigationBar) {
                navigationBar.classList.remove('showleft_menu');
            }
        }
    };

    const openMenu = () => {
        setOpenMenuState(true);
        sendGaThroughProps({
            data: {
                gaCategory: 'nav_menu',
                gaAction: 'hamburger_menu',
                gaLabel: 'hamburger_open',
            },
        });

        sendGaThroughProps({
            data: {
                gaCategory: 'mWeb_nav_menu_toi',
                gaAction: 'social_profile_icons',
                gaLabel: 'view',
                nonInteraction: true,
            },
        });
        if (printLayout && pageType !== 'printeditionas') {
            const navigationBar = document.getElementById('toi-print-navigation');
            if (navigationBar) {
                navigationBar.classList.add('showleft_menu');
            }
        }
    };

    return (
        <>
            <Wrapper>
                <EpapperHeaderContainer isWapView={isWapView}>
                    <EPapperLogoWrapper id="logowrapper">
                        {isWapView || isAppView ?
                            (<>
                                {!isAppView && <HamburgerWrapper onClick={openMenu}>
                                    <HamburgerIcon></HamburgerIcon>
                                    <HamburgerIcon></HamburgerIcon>
                                    <HamburgerIcon></HamburgerIcon>
                                </HamburgerWrapper>}
                                <Login
                                    isMobile={true}
                                    isEpaper={true} />


                                {!isAppView && openMenuState && (
                                    <LoadMenu
                                        closeMenu={closeMenu}
                                      //  killSwitch={ps}
                                        data={headerData}
                                        openMenu={openMenu}
                                        editionSwitch={headerData?.editionSwitch}
                                        currentCountry={currentCountry}
                                        notificationCenter={headerData?.notificationCenter}
                                        showTOIPlus={showTOIPlus}
                                        showToiPlusEntryPoints={showToiPlusEntryPoints}
                                        hideNotificationCenter
                                        msid={msid}
                                        articleSectionData={articleSectionData}
                                        newsData={newsData}
                                        isAppView={isAppView}
                                    />
                                )}
                                {isAppView ?
                                    <AppLogoWrapper>
                                        <ToiLogo></ToiLogo>
                                        <EpaperLogoWrapper></EpaperLogoWrapper>
                                    </AppLogoWrapper>:<a href="https://epaper.indiatimes.com">
                                        <ToiLogo></ToiLogo>
                                        <EpaperLogoWrapper></EpaperLogoWrapper>
                                     </a>
                                    }
                            </>) :
                            <> 
                            <EpaperLogo>
                            <a href='https://epaper.indiatimes.com'>
                                <img
                                    src="https://static.toiimg.com/photo/103688861.cms"
                                    
                                    alt="Times of India" />
                            </a>
                            </EpaperLogo>
                            <LogoSeprator />
                                <CheckOutsideClick onClickOutside={() => setShowList(false)}>
                                    <ReadPapper onMouseEnter={() => setShowList(true)}
                                        onMouseLeave={() => setShowList(false)}>
                                        <span><img
                                            src="https://static.toiimg.com/photo/103688857.cms"
                                            width={174}
                                            alt="Times of India" /></span>
                                        <ArrowIcon Type={showList ? 'listOpened' : ''}>
                                        </ArrowIcon>
                                        {showList && (
                                            <PublicationList>
                                                {dropDownEpaperData && Object.values(dropDownEpaperData).length > 0
                                                    ? Object.values(dropDownEpaperData).map((data: any) => {
                                                        return (
                                                            <PublicationListItem Type={data.name === 'The Times Of India' ? 'activeEpaper' : ''}>
                                                                <a href={data.href}>{data.name}</a>
                                                            </PublicationListItem>
                                                        );
                                                    })
                                                    : null}
                                            </PublicationList>
                                        )}
                                    </ReadPapper>
                                </CheckOutsideClick></>}
                    </EPapperLogoWrapper>
                    <EpaperTabs data={epapertabData} isWapView={isWapView} />
                    <EpaperHeaderRightContainer>

                        <CalendarWrapper id="epapercalendar" ref={calendarRef}>
                            <button
                                className={`epaper_inputcalendar ${showEpaperCalendar ? 'openCalendar' : ''}`}
                                onClick={(e) => { handleCalendarOpen(e) }}
                            >
                                {date ? format(date, "DD MMM YYYY") : null}
                            </button>
                            {showEpaperCalendar ? (
                                <div>
                                    <EpaperCalendar
                                        isWapView={isWapView}
                                        closeCalendar={closeCalendar}
                                        date={date}
                                        lastActiveDate={lastActiveDate}
                                        isAppView={isAppView}
                                    />
                                </div>
                            ) : null}
                        </CalendarWrapper>

                        {!isWapView && !isAppView && <EpapperHeaderLoginContainer> <Login
                            isMobile={false}
                            isEpaper
                        // query={this.props.query}
                        // pageType={pageType}
                        // toipLayout={toipLayout}
                        /></EpapperHeaderLoginContainer>}
                    </EpaperHeaderRightContainer>
                </EpapperHeaderContainer>
            </Wrapper>
        </>

    );
};


const Wrapper = styled.section`
    background: #fff;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.08);
    margin: 0 0 12px;
    padding: 12px 0;
    @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
        box-shadow: none;
        margin: 0;
        padding: 12px 0 0 0;
        // position: sticky;
        // top:0;
        // z-index: 1;
    }
`
const SocialDropdown = styled.section`
    position: absolute;
    box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.3);
    border: solid 1px #dcdcdc;
    border-radius: 8px;
    background-color: #fff;
    padding: 8px 8px 16px 8px;
    min-width: 180px;
    right: 20px;
    top: 30px;
    z-index: 1;
    ul li{
        width: 28%;
        margin-bottom: 12px;
    }
`


const Container = styled.section<IStyledHeader>`
    display: flex;
    justify-content:center;
    width:1168px;
    margin: 16px auto;
    @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
        flex-flow: column;
        padding:24px 24px 0;
        background:#fff;
        border-radius: 32px 32px 0 0;
        width:100%;
        position: relative;
        margin: 0 auto;    
    }
`

const NavWrapper = styled.section`
    width: 100%;
    background: #fff;
    border:1px solid #fff;
    box-shadow:0px 4px 4px rgba(0, 0, 0, 0.05);
    position:sticky;
    top: -1px;
    z-index: 3;
    ${(props: IStyledHeader) => props.isSticky == "No" && css`
        box-shadow: none;
        &>section{
            padding-top:0;
        }
    `}
`

const EPapperLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0;
  @media screen and ${device.mobile},
  screen and (orientation: landscape) and (max-width: 1000px) {
    width: auto;
  }
`;

const LogoSeprator = styled.span`
  width: 1px;
  display: inline-block;
  background-color: #ccc;
  height: 20px;
  margin: 0 11px;
`;

const SubHeaderWrapper = styled.div`
  border: solid 1px #e4e4e4;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.06);
  margin-bottom: 4px;
`;
const SubHeaderContainer = styled.div`
  width: 1168px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const EpapperHeaderContainer = styled.div`
  background: #fff;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0 24px;
  @media screen and (max-width: 1024px) {
    padding: 0 12px;
  }
    @media ${device.mobile} ,
    screen and (orientation: landscape) and (max-width: 1000px){ 
        width:100%;
        flex-direction: row;
        flex-wrap: wrap;
        padding: 0;
    }
    @media screen and (device-width: 712px) and (device-height: 1168px) and (orientation:portrait) {

        padding: 0 0 0 12px;
    }
`;

const EpaperLogo = styled.div`

    img{
        width: 74px;
        padding-top: 3px;
        @media screen and (device-width: 768px) and (device-height: 1024px) and (orientation:portrait) {
            width: 60px;
        }
    }
    
`

const EpaperHeaderRightContainer = styled.div`
width: auto;
display: flex;
align-items: center;
  // justify-content: center;
justify-content: space-between;
`;

const EpapperHeaderLoginContainer = styled.div`
  display: flex;
  //   align-items: center;
    // justify-content: center;
    justify-content: space-between;
    //background:red;
`;

const ReadPapper = styled.div`
  display: flex;
  align-items: center;
  position:relative;
  cursor:pointer;
  height:31px;
  span {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    min-width: 132px;
  }
  `;

const ArrowIcon = styled.div`
  margin-left: 12px;
  transition: transform .5s ease-in-out;
  background: no-repeat url('https://static.toiimg.com/photo/103780984.cms');
  background-size: 162px 104px;
  display: inline-block;
  width: 11px;
  height:6px;
  background-position:-42px -45px;
  ${(props: IStyledHeader) => props.Type == "listOpened" && css`
    transform: rotate(180deg);
    `}
`;

const PublicationList = styled.ul`
  padding: 8px 16px;
  border-radius: 4px;
  border: solid 1px #e4e4e4;
  background-color: #fff;
  list-style: none;
  position: absolute;
  width: 225px;
  font-size: 14px;
  min-width: 190px;
  top: 30px;
  left: 0;
  z-index: 99;
`;
const PublicationListItem = styled.li<IStyledHeader>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 1px #e4e4e4;
  cursor: pointer;
  padding: 8px 0;
  &:last-child{
    border-bottom: none;
  }
  ${(props: IStyledHeader) => props.Type == "activeEpaper" && css`
    &:after{
        background: no-repeat url('https://static.toiimg.com/photo/103780984.cms');
        content: '';
        background-size: 162px 104px;
        display: inline-block;
        width: 12px;
        height: 10px;
        background-position: -41px -78px;
        margin-left:15px;
    }
  `}
  a {
    display: block;
    width: 100%
  }
`;

const CalendarWrapper = styled.section`

`;

const HamburgerIcon = styled.section`
    min-width: 20px;
    height: 2px;
    margin: 2px 8px 4px 16px;
    background-color: #1a1a1a;
    border-radius: 10px;
    &::before,
    &::after {
      @include critical {
        content: '';
        background-color: #1a1a1a;
        border-radius: 2px;
        display: block;
        width: 20px;
        position: absolute;
        height: 1px;
        margin-top: -5px;
      }
    }

    &::after {
      @include critical {
        margin-top: 5px;
      }
    }
    `

const HamburgerWrapper = styled.section`
    @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
        width: auto;
        margin: -2px 8px 0 0;
    }
    `
const AppLogoWrapper = styled.section`
    padding:0 0 0 24px;
`
const ToiLogo = styled.section`
    background: url(https://static.toiimg.com/photo/105776877.cms) no-repeat;
    background-size: 450px;
    display: inline-block;
    width: 44px;
    height: 27px;
    background-position: -77px -206px;
}
`
const EpaperLogoWrapper = styled.section`
    width: 71px;
    height: 26px;
    background: url(https://static.toiimg.com/photo/105776877.cms) no-repeat; 
    background-size: 450px;
    display: inline-block;
    margin-left: 8px;
    background-position: -22px -53px;
`

export default EpaperHeaderV2;
